'use client';

import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Dialog,
  DialogActionButton,
  DialogCloseButton,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogIcon,
  DialogSubTitle,
  DialogTitle,
} from '@pickleballinc/ui/components/ui/dialog-v2';

interface DeleteGearDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting: boolean;
}

export function DeleteGearDialog({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  isDeleting,
}: DeleteGearDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogIcon>
            <div className='flex items-center justify-center rounded-full bg-error-100 p-3 size-12'>
              <FontAwesomeIcon icon={faTrashCan} className='size-5 text-error-500' />
            </div>
          </DialogIcon>
          <DialogTitle>Delete Gear</DialogTitle>
          <DialogSubTitle>Are you sure you want to delete this gear from your list?</DialogSubTitle>
        </DialogHeader>

        <DialogFooter>
          <DialogCloseButton disabled={isDeleting} onClick={onCancel}>
            Cancel
          </DialogCloseButton>
          <DialogActionButton disabled={isDeleting} onClick={onConfirm}>
            Delete
          </DialogActionButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
